// Header.jsx
import { useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import logo from '../img/usojobanicB.png';
import { Button } from "../components/Button";
import "../css/Header.css";

export default function Header() {
  const [showSubMenu, setShowSubMenu] = useState(false);
  const submenuRef = useRef(null);
  const navigate = useNavigate();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLoginClick = () => {
    navigate("/Login");
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (submenuRef.current && !submenuRef.current.contains(event.target)) {
        setShowSubMenu(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleSubMenu = () => {
    setShowSubMenu((prev) => !prev);
  };

  return (
    <header className="header">
      <div className="header-logo-container">
        <a href="/" className="header-logo-container">
          <img src={logo} alt="Logo" className="header-logo" />
          <span className="header-company-name">Usojobanic RC</span>
        </a>
      </div>

      <button className="mobile-menu-icon" onClick={toggleMobileMenu}>
        <i className={isMobileMenuOpen ? "bi bi-x-lg" : "bi bi-list"}></i>
      </button>

      {/* Añadimos la clase dinámica 'nav-open' según el estado */}
      <nav className={`header-nav ${isMobileMenuOpen ? "nav-open" : ""}`}>
        <ul className="header-nav-list">
          <li><a href="/">INICIO</a></li>
          <li className="header-submenu-container" ref={submenuRef}>
            <button className="header-submenu-toggle" onClick={toggleSubMenu}>
              CONÓCENOS <i className="bi bi-caret-down"></i>
            </button>
            {showSubMenu && (
              <ul className="header-submenu">
                <li><a href="/mision">Misión</a></li>
                <li><a href="/vision">Visión</a></li>
                <li><a href="/principios">Principios</a></li>
                <li><a href="/circuitos">Circuitos</a></li>
              </ul>
            )}
          </li>
          <li><a href="/eventos-publicos">EVENTOS</a></li>
          <li><a href="/">CONTACTANOS</a></li>
          <li><Button name="Ingresa" onClick={handleLoginClick} /></li>
        </ul>
      </nav>

    </header>
  );
}